// The profile loaded by this document stays fixed until a full navigation. In particular, a
// delayed callback after a switch must not silently acquire the next organization's authority.
import axios from 'axios'

import { cancelPendingLogout } from './logout'
let documentMembership: string | undefined

export const bindOrganizationMembership = (membership: string | undefined) => {
  if (!documentMembership && membership) documentMembership = membership
}

export const getOrganizationMembership = () => documentMembership

export const resetOrganizationMembership = () => {
  documentMembership = undefined
}

export const reportOrganizationChanged = () => {
  window.dispatchEvent(new Event('organization-changed'))
}

export const requestOrganizationSwitch = (membership: string, current: string) => {
  cancelPendingLogout()
  return axios.post(
    '/api/v1/auth/memberships/',
    { membership },
    { headers: { 'X-Organization-Membership': current }, timeout: 10000 }
  )
}
